<script>
import { ref } from 'vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'
import { useDeliveredAtField } from '../../../../../Composables/DeliveryOrder/useDeliveredAtField.ts'
import FormCreator from '../../UI/Form/FormCreator.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'
import EquipmentFormAndModal from '../../Equipment/EquipmentFormAndModal.vue'
import SignatureBlock from '../SignatureBlock.vue'
import DeliveryOrderAddressField from './DeliveryOrderAddressField.vue'

export default {
  components: { DeliveryOrderAddressField, EquipmentFormAndModal, FieldCreator, FormCreator, SignatureBlock },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    contractId: { type: Number, required: true },
    deliveryOrderId: { type: Number, required: false },
    uuid: { type: String, required: false },
    reload: { type: Boolean },
    new: { type: Boolean },
    esignContract: { type: Boolean, required: true },
  },

  data: function () {
    return {
      equipments: [],
      checkedEquipments: [],
      supplierId: null,
      loading: false,
      sending: false,
      loadField: false,
      params: {},
      def: {},
      supplierRequired: false,
      formData: null,
    }
  },

  computed: {
    getSupplier: function () {
      if (this.deliveryOrder.supplier != null) {
        if (this.deliveryOrder.supplier.id != null) {
          this.sortEquipmentsBySupplier()
        }

        return this.deliveryOrder.supplier.name
      }

      return null
    },
    canSelectSupplier: function () {
      return !this.supplierId || !this.deliveryOrder.id
    },
    clientIdList: function () {
      return {
        supplier: this.supplierId ?? this.def.supplier.options.choices[0]?.id ?? null,
      }
    },
    getSupplierDef: function () {
      this.sortEquipmentsBySupplier()
      let defSupplier = { id: this.def.supplier.options.choices[0].id, name: this.def.supplier.options.choices[0].name }
      this.supplierId = defSupplier.id
      this.deliveryOrder.supplierId = defSupplier.id
      return defSupplier.name
    },
    isSalesmanSignatureRequired() {
      return Object.hasOwn(this.def, 'signerSalesman') && this.deliveryOrder.supplier === null
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    isLoading(bool) {
      this.loading = bool
    },
    isSending(bool) {
      this.sending = bool
    },
    globalBuild({ loading, build, def, object }) {
      this.loading = loading

      if (build) {
        this.def = def
        this.deliveryOrder = object

        this.supplierRequired = this.isSalesmanSignatureRequired

        this.sortEquipments()
        this.checkedEquipments =
          this.deliveryOrder.equipments.length > 0
            ? this.deliveryOrder.equipments.map((equipment) => {
                return JSON.stringify({ supplier: equipment.supplier.id, equipment: equipment.id })
              })
            : this.deliveryOrder.equipments

        this.loadField = build
      }
    },
    setDatas(json) {
      location.reload()
    },
    getSupplierChange(val, choices) {
      if (val) {
        if (this.supplierRequired) {
          this.supplierRequired = false
        }

        this.getJSON('users/entity/' + val).then(() => {
          this.deliveryOrder.supplierId = val
          this.params.supplierId = val

          this.$nextTick(() => {
            this.$refs.formdelivery.get().then(() => {
              this.sortEquipmentsBySupplier(val)
            })
          })
        })
      } else {
        this.supplierRequired = this.isSalesmanSignatureRequired

        this.sortEquipments()
      }
    },
    isChecked: function (id, serialNumber) {
      //nécessaire pour faire fonctionnner l'event de la checkbox
      if (serialNumber == null) {
        this.$refs['serialNumberMissing' + id][0].innerHTML =
          '<span style="color:red;">' + this.$t('equipment.fields.missing.serialNumber') + '</span>'

        //supprime l'élément checked
        //this.checkedEquipments = this.checkedEquipments.filter((el) => { let detail = JSON.parse(el); return detail.equipment != id });
      }
    },
    checkAll() {
      if (this.checkedEquipments.length == 0) {
        this.checkedEquipments = this.def.equipments.options.choices.map((equipment) => {
          if (!equipment.deliveryOrderId || this.supplierId) {
            if (equipment.serialNumber == null) {
              this.$refs['serialNumberMissing' + equipment.id][0].innerHTML =
                '<span style="color:red;">' + this.$t('equipment.fields.missing.serialNumber') + '</span>'
            }
            let supplierId = this.supplierId ? this.supplierId : equipment.supplier.id
            return JSON.stringify({ supplier: supplierId, equipment: equipment.id })
          }
        })
        this.checkedEquipments = this.checkedEquipments.filter((e) => e)
      } else {
        this.checkedEquipments = []
      }
    },
    sortArray: function (array) {
      let i = 0
      for (const [key, value] of Object.entries(array)) {
        array.splice(i, 0, array.splice(key, 1)[0])
        i++
      }

      const filtered = array.filter((el) => {
        return el !== null && typeof el !== 'undefined' && el != ''
      })

      return filtered
    },
    sortEquipments: function () {
      this.equipments = []

      for (const [index, equipment] of Object.entries(this.def.equipments.options.choices)) {
        equipment.class = !(equipment.deliveryOrderId === this.deliveryOrderId)
        this.equipments[index] = equipment
      }

      return this.equipments
    },
    sortEquipmentsBySupplier: function (supplierId = null) {
      this.equipments = []

      for (const [index, equipment] of Object.entries(this.def.equipments.options.choices)) {
        if (
          (equipment.supplier &&
            this.deliveryOrder.supplier &&
            equipment.supplier.id === this.deliveryOrder.supplier.id) ||
          this.def.supplier.options.choices.length == 1 ||
          (equipment.supplier && supplierId == equipment.supplier.id)
        ) {
          if (this.new) {
            equipment.class = !!equipment.deliveryOrderId
          } else {
            equipment.class = true
          }
          this.equipments[index] = equipment
        }
      }

      this.equipments = this.sortArray(this.equipments)
      return this.equipments
    },
    equipmentSent(e) {
      for (const [index, equipment] of Object.entries(this.def.equipments.options.choices)) {
        if (e.id == equipment.id) {
          this.setValue(this.equipments, index, e)
          this.def.equipments.options.choices = this.equipments
          this.$refs['serialNumberMissing' + e.id][0].innerHTML = e.serialNumber
        }
      }
    },
    send() {
      let details = this.checkedEquipments.map((equipmentDetail) => {
        return JSON.parse(equipmentDetail)
      })
      this.$refs['formdelivery'].datas['equipments'] = details.map((detail) => {
        return detail.equipment
      })
      if (details.length === 0) {
        this.$refs.missing.textContent = this.$t('equipment.fields.missing.equipments')
        return
      }
      this.$refs['formdelivery'].datas['supplier'] =
        this.deliveryOrderId && this.deliveryOrder.supplier ? this.deliveryOrder.supplier.id : details[0].supplier
      this.$refs['formdelivery'].datas['contractId'] = this.contractId

      if (this.$refs['formdelivery'].datas['deliveryPlace'] || this.$refs['formdelivery'].datas['deliveryAddress']) {
        this.$refs['formdelivery'].methods()
      } else {
        this.$refs.missing.textContent = this.$t('equipment.fields.missing.deliveryAddress')
        return
      }
    },
  },

  beforeMount: function () {
    this.params = this.deliveryOrderId ? { deliveryOrderId: this.deliveryOrderId } : { contractId: this.contractId }
  },
  setup() {
    const deliveryOrder = ref(null)
    const { mandatory } = useDeliveredAtField(deliveryOrder)

    return { deliveryOrder, deliveredAtMandatory: mandatory }
  },
  watch: {
    deliveredAtMandatory(required) {
      this.def.deliveredAt.options.required = required
    },
  },
}
</script>
<template>
  <div id="delivery">
    <FormCreator
      @update-data="updateData"
      ref="formdelivery"
      endpoint="v2/deliveryorder"
      src-error="formdelivery"
      :uuid="uuid"
      :id="deliveryOrderId"
      :params="params"
      class-to-add="d-none"
      @is-sending="isSending"
      @global-build="globalBuild"
      @form-return="setDatas"
    />

    <div v-if="deliveryOrder !== null">
      <div class="d-flex justify-content-between">
        <div v-if="!canSelectSupplier" class="my-3 font-weight-bold">
          {{ $t('equipment.fields.supplier.title') }} :
          <span e2e-data="deliveryOrderSupplierName">{{ getSupplier }}</span>
        </div>
        <div v-else-if="def && def.supplier.options.choices.length === 1" class="my-3 font-weight-bold">
          {{ $t('equipment.fields.supplier.title') }} :
          <span e2e-data="deliveryOrderSupplierName">{{ getSupplierDefDef }}</span>
        </div>
        <div v-else>
          <FieldCreator
            v-if="loadField"
            :form-data="formData"
            name="supplier"
            form-ref="formdelivery"
            domain="delivery"
            label-top
            @get-select-change="getSupplierChange"
          />
        </div>
        <div v-if="!user?.isReadOnly" class="d-flex align-items-center">
          <label for="checks" class="fs-16 font-weight-bold mb-0 mr-1">{{ $t('delivery.checkAll') }}</label>
          <input type="checkbox" id="checks" @change="checkAll()" e2e-button="deliveryOrderCheckAll" />
        </div>
      </div>
      <div v-if="!supplierRequired" style="overflow-x: auto">
        <table class="table table-striped fs-16">
          <thead>
            <tr>
              <th v-if="!deliveryOrder.supplier">{{ $t('equipment.fields.supplier.title') }}</th>
              <th>{{ $t('equipment.fields.brand.label') }}</th>
              <th>{{ $t('equipment.fields.model.label') }}</th>
              <th>{{ $t('equipment.fields.serialNumber.label') }}</th>
              <th v-if="deliveryOrder.isEquipmentsVehicule">{{ $t('equipment.fields.plate.label') }}</th>
              <th class="text-right">{{ $t('equipment.fields.unitAmount.label') }}</th>
              <th class="text-right">{{ $t('equipment.fields.quantity.label') }}</th>
              <th class="text-right">{{ $t('equipment.fields.amount.label') }}</th>
              <th v-if="!user?.isReadOnly"></th>
              <th v-if="!user?.isReadOnly"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(equipment, index) in equipments"
              :class="equipment.class ? 'bg-grey' : ''"
              :key="equipment.id"
              :e2e-row="'deliveryOrderEquipment-' + index"
            >
              <td v-if="!deliveryOrder.supplier" e2e-data="deliveryOrderEquipmentSupplierName">
                {{ equipment.supplier ? equipment.supplier.name : '' }}
              </td>
              <td e2e-data="deliveryOrderEquipmentBrand">{{ equipment.brand }}</td>
              <td e2e-data="deliveryOrderEquipmentModel">{{ equipment.model }}</td>
              <td :ref="'serialNumberMissing' + equipment.id" e2e-data="deliveryOrderEquipmentSerialNumber">
                {{ equipment.serialNumber }}
              </td>
              <td v-if="deliveryOrder.isEquipmentsVehicule" e2e-data="deliveryOrderPlate">
                {{ equipment?.plate ?? '-' }}
              </td>
              <td class="text-right" e2e-data="deliveryOrderEquipmentUnitAmount">
                {{ $n(Number(equipment.unitAmount ?? 0.0)) }}
              </td>
              <td class="text-right" e2e-data="deliveryOrderEquipmentQuantity">{{ equipment.quantity }}</td>
              <td class="text-right" e2e-data="deliveryOrderEquipmentAmount">
                {{ $n(Number(equipment.amount ?? 0.0)) }}
              </td>
              <td v-if="!user?.isReadOnly">
                <input
                  type="checkbox"
                  ref="inputCheckbox"
                  :id="equipment.id"
                  :class="equipment.class ? 'd-none' : ''"
                  v-model="checkedEquipments"
                  :value="
                    JSON.stringify({
                      supplier: equipment.supplier ? equipment.supplier.id : null,
                      equipment: equipment.id,
                    })
                  "
                  :checked="equipment.deliveryOrder != null"
                  @change="isChecked(equipment.id, equipment.serialNumber)"
                  e2e-input="deliveryOrderEquipmentChecked"
                />
              </td>
              <td v-if="!user?.isReadOnly">
                <EquipmentFormAndModal
                  :class="equipment.class ? 'd-none' : ''"
                  :equipment="equipment"
                  :main-id="equipment.mainId"
                  @equipment-sent="equipmentSent"
                ></EquipmentFormAndModal>
                <div v-if="equipment.deliveryOrder != null">
                  <p v-if="equipment.deliveryOrder.status == 'CREATED'" class="mb-0">
                    {{ $t('equipment.delivery.created') }}
                  </p>
                  <p v-if="equipment.deliveryOrder.status == 'SIGNED'" class="mb-0">
                    {{ $t('equipment.delivery.signed') }}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="!supplierRequired" class="row">
        <div v-if="def.deliveryAddress?.options?.display" class="col-md-6">
          <DeliveryOrderAddressField :form="formData" :entity-id="deliveryOrder.clientId" label-top />
        </div>
        <div
          v-if="def?.deliveryAddress?.options?.display && def?.deliveryPlace?.options?.display"
          class="col-md-1 d-flex justify-content-center align-items-center"
        >
          <p class="font-weight-bold mx-3 my-3" style="font-size: 20px">ou</p>
        </div>
        <div v-if="def?.deliveryPlace?.options.display" class="col-md-5">
          <FieldCreator
            :form-data="formData"
            v-if="loadField"
            name="deliveryPlace"
            form-ref="formdelivery"
            domain="delivery"
            label-top
          />
        </div>
      </div>
      <div v-if="!supplierRequired" class="row">
        <div class="col-md-6">
          <FieldCreator
            :form-data="formData"
            v-if="loadField"
            name="deliveredAt"
            form-ref="formdelivery"
            domain="delivery"
            :label-top="true"
            :min-datetime="deliveryOrder.contractSignedAt"
          ></FieldCreator>
        </div>
        <div class="col-md-6">
          <FieldCreator
            :form-data="formData"
            v-if="loadField"
            name="operationalAt"
            form-ref="formdelivery"
            domain="delivery"
            :label-top="true"
          ></FieldCreator>
        </div>
      </div>
      <SignatureBlock
        :form-data="formData"
        :object="deliveryOrder"
        v-if="loadField"
        :contract-id="contractId"
        :client-id="deliveryOrder.clientId"
        form-ref="formdelivery"
        :form-instance="$refs.formdelivery"
        label-top
        two-cols
        classes="mb-4"
        :client-id-list="clientIdList"
      />
      <div
        v-if="conf.signDelivery && esignContract && deliveryOrder.signDeliveryOrder && !supplierRequired"
        class="my-4 py-3 col-11 mx-auto bg-info"
        style="border-radius: 1em"
      >
        <div class="text-center">{{ $t('delivery.signStatus') }}</div>
        <div class="row d-flex justify-content-center" style="margin: 1em auto">
          <FieldCreator
            v-if="loadField"
            :form-data="formData"
            name="esign"
            form-ref="formdelivery"
            domain="delivery"
            @checked="deliveryOrder.esign = $event"
          />
        </div>
      </div>
      <div v-if="!user?.isReadOnly && !supplierRequired" class="text-center">
        <button class="btn btn-primary" @click="send">
          <div v-if="sending" class="d-flex justify-content-center align-items-center flex-fill">
            <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <span v-else e2e-button="deliveryOrderCreate">{{ $t('delivery.create') }}</span>
        </button>
      </div>
      <div class="text-center mt-1">
        <span ref="missing" style="color: red"></span>
      </div>
    </div>
  </div>
</template>
